import CompleteSearchResult from "src/components/search/CompleteSearchResult";
import StreamingguideLogo from "src/components/streaming/StreamingguideLogo";
import { setDefaultCacheHeaders } from "src/lib/server/cache";
import { ICommonProps, getServerData } from "src/lib/server/sanity";
import { GetServerSideProps } from "next";
import ContentWrapper from "src/components/contentwrapper/ContentWrapper";
import styled from "src/lib/styles/css";
import StickyBottomAd from "src/components/ads/StickyBottomAd";
import AdUnitWithPosition from "src/components/forsiden/AdUnitWithPosition";
import { useOverriddenAdunits } from "src/lib/server/ads";
import AdWrapper from "src/lib/contexts/AdContext";

//#region [Other] getServerSideProps
export const getServerSideProps: GetServerSideProps = getServerData(async (context) => {

    setDefaultCacheHeaders(context);

    return {
        props: {
        }
    }

});
//#endregion

//#region [Props]
type CompleteSearchProps = {
    isStreamingOnly?: boolean;
} & ICommonProps;
//#endregion

//#region [Component]
export default function CompleteSearch({ appData, isStreamingOnly = false, hasSponsor, sponsorTopImageDesktop, sponsorTopImageMobile, sponsorClickUrl, adUnits }: CompleteSearchProps) {
    const useAzureSearch = process.env.NEXT_PUBLIC_USE_AZURE_SEARCH === "true";
    const finalAdUnits = useOverriddenAdunits(ADS, adUnits);
    const hasPackshot = finalAdUnits.find(adUnit => adUnit.targetId === "FW_bottomSticky")?.isPackshot ?? false;
    return <SContentWrapper>
        <AdWrapper ads={finalAdUnits}>
            {isStreamingOnly && <StreamingguideLogo />}
            <CompleteSearchResult isStreamingOnly={isStreamingOnly} azureSearchEnabled={useAzureSearch} hasSponsor={hasSponsor} sponsorTopImageDesktop={sponsorTopImageDesktop} sponsorTopImageMobile={sponsorTopImageMobile} sponsorClickUrl={sponsorClickUrl} customSortNum={process.env.NEXT_PUBLIC_SEARCH_CUSTOM_SORT}/>
            <StickyBottomAd isPackshot={hasPackshot} />
        </AdWrapper>
    </SContentWrapper>;
}
//#endregion

//#region [Styles]
const SContentWrapper = styled(ContentWrapper)`
    padding: 0 15px;
`;
//#endregion

const ADS: AdUnitWithPosition[] = [
    { auId: '3c3cd5', auW: '50vw', targetId: 'FW_bottomSticky', requestMode: "hasTarget" },

];